import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=6bc54acc&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc54acc')) {
      api.createRecord('6bc54acc', component.options)
    } else {
      api.reload('6bc54acc', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=6bc54acc&", function () {
      api.rerender('6bc54acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Upkm79RRo1ZC/JS/comp/ImgFallback.vue"
export default component.exports